"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var bi_logger_ec_sf_1 = tslib_1.__importDefault(require("@wix/bi-logger-ec-sf"));
exports.createOOIStoreFrontBILogger = function (userId, biToken, defaults, biLogger, debug) {
    if (defaults === void 0) { defaults = {}; }
    if (debug === void 0) { debug = false; }
    var defaultsWithId = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, defaults), { bi_token: biToken }), userId);
    var loggerInstance = bi_logger_ec_sf_1.default(biLogger)({
        host: debug ? 'frog.wixpress.com' : undefined,
    });
    loggerInstance.util.updateDefaults(defaultsWithId);
    return loggerInstance;
};
//# sourceMappingURL=configure-ooi-front-bi-logger.js.map